import type { GridProps } from '@mui/material/Grid'
import { GridSpacing } from '@mui/material'

type ColumnSize = GridProps['xs']

export class DataGridSettings {
  public spacing: GridSpacing = 0
  public sortingMode: 'single' | 'multiple' = 'single'
  public columns: DataColumnSettings[] = []

  public static instance(defaults: DataGridSettings) {
    const instance = new DataGridSettings()
    Object.assign(instance, defaults)
    return instance
  }

  public static defaultSorters(settings: DataGridSettings): SortField[] {
    return settings.columns
      .filter((column) => column.sortOrder)
      .map((column) => {
        return {
          dataField: column.dataField,
          sortOrder: column.sortOrder
        } as SortField
      })
  }
}

export class DataColumnSettings {
  public title: string = ''
  public dataField: string = ''
  public allowSorting: boolean = true
  public sortOrder?: SortOrder
  public xs: ColumnSize = 1
  public sm?: ColumnSize
  public lg?: ColumnSize
  public childComp?: boolean
}

export class SortField {
  public dataField: string = ''
  public sortOrder: SortOrder = 'ASC'
}

export type SortOrder = 'ASC' | 'DESC'
